export default "__VITE_ASSET__DGzW9N_G__"